import { render } from "./Loading.vue?vue&type=template&id=5140bdd6&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=5140bdd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5140bdd6"

export default script